<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television</v-icon>
        <span>Tarja</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir câmera na tarja"
      message="Tem certeza que deseja exibir a câmera na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loading"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    idCamera: Number,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    if (this.codProducao) {
      await this.getConfigTarja({ cod_producao: this.codProducao });
      this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
    }
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja/getterConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "cameras/assignTarjaParams",
      getConfigTarja: "tarja/getConfigTarja",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setCameraTarja({
          codProducao: this.codProducao,
          idCamera: this.idCamera,
        });
      }
    },
    confirmExibir() {
      this.setCameraTarja({
        codProducao: this.codProducao,
        idCamera: this.idCamera,
      });
    },
    async setCameraTarja(value) {
      this.loading = true;
      this.assignTarjaParams(value);
      localStorage.setItem("tarjaCameraParams", JSON.stringify(value));
      this.$emit("change");
      setTimeout(() => {
        this.loading = false;
        this.showDialog = false;
      }, 250);
    },
  },
  watch: {
    "$store.state.tarja.configTarja": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
    codProducao: async function (value) {
      await this.getConfigTarja({ cod_producao: value.codProducao });
    },
  },
};
</script>

